import React, { useCallback, useEffect, useState } from 'react';
import { Button, Input, Select } from 'semantic-ui-react';

const Filters = (props: any) => {
  const { allowedParams, filteredLists, setFilteredLists, originalList } =
    props;

  const [currentFilter, setCurrentFilter] = useState(
    allowedParams && allowedParams.length > 0
      ? {
          name: allowedParams[0],
          value: '',
        }
      : { name: '', value: '' }
  );
  const [allowedFilters] = useState(
    allowedParams.map((param) => ({ param, value: param, text: param }))
  );
  const filter = useCallback(
    (listArray: []) => {
      let _filteredLists = listArray.filter(
        (listItem: { [key: string]: string }) => {
          if (
            listItem[currentFilter.name]
              ?.toString()
              .toLowerCase()
              .includes(currentFilter.value?.toString().toLowerCase().trim())
          ) {
            return true;
          } else return false;
        }
      );

      return _filteredLists;
    },
    [currentFilter]
  );

  useEffect(() => {
    const newFilteredLists = filter(originalList);
    if (JSON.stringify(newFilteredLists) !== JSON.stringify(filteredLists))
      setFilteredLists(newFilteredLists);
  }, [originalList, filteredLists, setFilteredLists, filter]);

  const handleChange = (e, { value }) => {
    if (currentFilter.name) {
      setCurrentFilter({
        ...currentFilter,
        value: String(value),
      });
    }

    setFilteredLists(filter(filteredLists));
  };
  return (
    <>
      <Select
        placeholder="Select your filter"
        options={allowedFilters}
        value={currentFilter.name}
        onClick={() => {}}
        onChange={(e, { value }) => {
          setCurrentFilter({
            ...currentFilter,
            name: String(value),
          });
        }}
      />
      <Input
        focus
        placeholder={currentFilter.name ? 'Search...' : 'Choose a filter'}
        value={currentFilter.value || ''}
        onChange={handleChange}
      />
      <Button
        secondary
        onClick={() => {
          setCurrentFilter({
            name: currentFilter.name,
            value: '',
          });

          setFilteredLists(filteredLists);
        }}
      >
        Clear
      </Button>
    </>
  );
};

export default Filters;
